
import { Component, Ref, PropSync, Vue, Prop } from "vue-property-decorator";
import { Form } from "element-ui";

import { saveOrUpdateMerchantIntelligent } from "@/api/dialectic"

@Component({ name: 'dialectic-components-merchantForm',
    components: {
    }
})
export default class MerchantDialecticForm extends Vue {
    @Ref("formRef") validateFormRef: Form;
    @Prop({ default: [] }) symptomTypeOptions !: Array<any>
    @PropSync("form") modelForm !: any;
    @PropSync("visible") modelVisible !: boolean;
    @Prop({ default: "" }) merchantId !: string;

    formRule = {
        symptomType: { required: true, message: "请选择类型" },
        symptomName: { required: true, message: "请输入名称" },
        gender: { required: true, message: "请选择适用人群" },
    }

    get dialogTitle(){
        return this.modelForm.id ? "编辑" : "新增";
    }
    dialogCloseFun() {
        this.modelVisible = false;
        this.validateFormRef?.resetFields();
    }

    dialogSave() {
        this.validateFormRef?.validate().then(() => {
            // NOTE: 品牌方侧只维护 类型/名称/适用人群，状态在列表内切换；symptomStatus 由父组件回填（新增默认启用）
            const params = {
                ...this.modelForm,
                merchantId: this.merchantId,
                symptomStatus: Number(this.modelForm.symptomStatus),
            }
            saveOrUpdateMerchantIntelligent(params).then((res) => {
                this.$message.success("操作成功");
                this.dialogCloseFun();
                this.$emit("syncList")
            })
        });
    }
}


